import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _exsitInsuranceTypeMa;

import { InsuranceType } from '../shared/generated';
var CHUBB = [{
  label: 'Professional Indemnity',
  value: 'professional-indemnity'
}, {
  label: 'Public Liability',
  value: 'public-liability'
}, {
  label: 'Employers Liability',
  value: 'employers-liability'
}, {
  label: 'Directors & officers',
  value: 'directors-officers'
}, {
  label: 'Corporate legal liability',
  value: 'corporate-legal-liability'
}, {
  label: 'Employment practices',
  value: 'employment-practices'
}, {
  label: 'Cyber liability cover',
  value: 'cyber-liability'
}, {
  label: 'Cyber crime cover',
  value: 'cyber-crime'
}, {
  label: 'Property cover',
  value: 'property-cover'
}, {
  label: 'Business HR cover',
  value: 'business-hr-cover'
}];
export var insuranceTypes = {
  CHUBB: CHUBB
};
export var exsitInsuranceTypeMappingToQuoteInsuranceType = (_exsitInsuranceTypeMa = {}, _defineProperty(_exsitInsuranceTypeMa, InsuranceType.GOODS_IN_TRANSIT_INSURANCE, 'goods-in-transit'), _defineProperty(_exsitInsuranceTypeMa, InsuranceType.BUSINESS_INSURANCE, 'business-insurance'), _defineProperty(_exsitInsuranceTypeMa, InsuranceType.CONSTRUCTION_INSURANCE, 'hired-in-plant'), _exsitInsuranceTypeMa);